import { render } from "./shortcuts.vue?vue&type=template&id=22f849b0&ts=true"
import script from "./shortcuts.ts?vue&type=script&lang=ts&external"
export * from "./shortcuts.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__